/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../tslib.es6-e01eabb2.js';
import { m as index$r } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import setNavigationBarTitle$3 from './cn/index.js';
import setNavigationBarTitle$4 from './cnStation/index.js';
import setNavigationBarTitle$2 from './dingTalk/index.js';
import setNavigationBarTitle$1 from './browser/index.js';
import setNavigationBarTitle$5 from './panguMiniApp/index.js';
import mini from './mini/index.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var apiConfig = {
    web: {
        browser: setNavigationBarTitle$1,
        dingTalk: setNavigationBarTitle$2,
        dingTalkPC: setNavigationBarTitle$2,
        windvane: {
            cn: setNavigationBarTitle$3,
            cnStation: setNavigationBarTitle$4,
        },
    },
    mini: mini,
    panguMiniApp: setNavigationBarTitle$5,
};
// @uni库里，使用setNavigationBarTitle作为统一命名。
var extendSetNavigationBarTitle = extend(apiConfig, index$r);
/**
 * 设置导航栏标题。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
 * @param title
 * @param params
 * @example 使用案例：
 * import { setNavigationBarTitle } from '@alife/cn-uni-api';
 *  setNavigationBarTitle('测试标题')
 *    .then(() => {
 *      console.log('success');
 *    })
 *    .catch((error) => {
 *      console.log(error);
 *    });
 * @author 敬文
 */
var setNavigationBarTitle = function (title, params) {
    if (typeof title === 'string') {
        return extendSetNavigationBarTitle(__assign(__assign({}, params), { title: title }));
    }
    return extendSetNavigationBarTitle(title);
};

export { setNavigationBarTitle };
